module.exports = __webpack_public_path__ + "img/hero-product.7e841873.png";